/* eslint-disable no-console */
import type { EventProperties } from '../types/EventProperties';
import { Analytics } from './Analytics';

export class ConsoleAnalytics extends Analytics {
  identify(userId: string): void {
    console.log('[Analytics] identify:', userId);
  }

  reset(): void {
    console.log('[Analytics] reset');
  }

  captureEvent(eventName: string, properties: EventProperties): void {
    console.log('[Analytics] event:', eventName, properties);
  }

  setUserProperties(properties: EventProperties): void {
    console.log('[Analytics] user properties set:', properties);
  }

  setGlobalProperties(properties: EventProperties): void {
    console.log('[Analytics] global properties set:', properties);
  }

  forceStartSessionRecording(): void {
    console.log('[Analytics] force start session recording requested');
  }
}
